import { gql } from '@apollo/client';

export default gql`
  mutation editInspectionResult(
    $id: ID!
    $doneAt: ISO8601DateTime
    $result: Int
    $notes: String
    $inspectionFields: [InspectionFieldExecutionInput!]
  ) {
    editInspectionResult(
      input: {
        id: $id
        doneAt: $doneAt
        result: $result
        notes: $notes
        inspectionFields: $inspectionFields
      }
    ) {
      inspectionResult {
        id
        doneAt
        result
        notes
        inspectionResultFields {
          id
          inspectionFieldId
          name
          order
          value
        }
      }
    }
  }
`;
